import React from 'react';
import { Link } from 'react-router-dom';
import Avatar from '../Avatar';

const Card = ({ category }) => (
  <>
    <div className="icon">
        <i className={category.iconClass}></i>
    </div>
    <div className="inner-content">
        <h2 className="title is-4">{category.title}</h2>
        <div className="inner-text">
            {category.content}
        </div>
        <div className="card-meta">
            {
              category.avatars.map(a => (
                <Avatar avatarUrl={a} />
              ))
            }
            <div className="meta-info">
                <div className="articles-number">Bu bölümde {category.documentsLength} doküman var.</div>
                <div className="authors">Hazırlayan <span>{category.author}</span>{category.avatars.length > 1 ? ` ve ${category.avatars.length - 1} kişi daha`: ''}</div>
            </div>
        </div>
    </div>
  </>
);

const Category = ({ categories }) => (
  <section className="section help-section">
  <div className="container">
      <div className="columns is-vcentered">
          <div className="column"></div>
          <div className="column is-9">
            {
              categories.map(c => (
                <div className="flex-card category-card light-bordered">
                    <div className="card-body">
                      {
                        c.url === '##'
                          ? (
                            <div>
                              <Card category={c} />
                            </div>
                          )
                          : (
                            <a href={c.url}>
                              <Card category={c} />
                            </a>
                          )
                      }
                    </div>
                </div>
              ))
            }
          </div>
          <div className="column"></div>
      </div>
  </div>
  </section>
);

export default Category;
